var cache = {},
	getData = function(options) {
		var cackeKey = options.cacheKey,
			url = options.url,
			callback = options.callback,
			requestData = options.requestData,
			fromCache = cache[cackeKey],
			ajax,
			data = false;

		if(typeof fromCache !== 'undefined') {
			if(fromCache && fromCache.readyState) {
				ajax = fromCache;
			} else {
				data = fromCache;
				callback(data);
			}
		} else {
			ajax = $.ajax({
				url: window.appConfig.gatewayUrl + url,
				dataType: 'jsonp',
				data: requestData
			});

			cache[cackeKey] = ajax;

			data = false;
		}

		if(ajax) {
			ajax.then(function(response) {
				if(response.success) {
					if(!response.data || (_.isArray(response.data) && !response.data.length)) {
						data = false;
					} else {
						data = response.data;
					}

					cache[cackeKey] = data;
				} else {
					data = false;
				}

				callback(data);
			});
		}

		return data;

	};

let partialPaymentService = {
	getByCountry:function(options) {
		return getData({
			url:"/apiV1/firstPaymentDefinition/getByCountry",
			callback:options.callback || function(){},
			cacheKey:options.countryId,
			requestData:{
				countryId:options.countryId
			}
		});
	},
	getByCountryAndOperator:function(options) {
		return getData({
			url:"/apiV1/firstPaymentDefinition/getByCountryAndOperator",
			callback:options.callback || function(){},
			cacheKey:options.countryId + '_' + options.operatorId,
			requestData:{
				countryId:options.countryId,
				operatorId: options.operatorId
			}
		});
	},
};

export default partialPaymentService;



